import React, { useState, useEffect, Component } from 'react';
import { Link } from 'react-router-dom';
import admin from "../../images/banner/admin.png";
import deleteicon from "../../images/icon/delete.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from 'axios';

function Submissions(){
    const [records, setRecords] = useState([]);
    const [consultants, setConsultants] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchConsultant, setSearchConsultant] = useState('');

    useEffect(() => {
        axios.get("https://api.transnational.ai/api/submissions") 
            .then(response => {
                console.log(response.data)
                setRecords(response.data.submissions);
            })
            .catch(error => {
                console.error('Error fetching records:', error);
            });
    }, []);
    
    useEffect(() => {
        axios.get("https://api.transnational.ai/api/consultants") 
            .then(response => {
                console.log(response.data)
                setConsultants(response.data.consultants);
            })
            .catch(error => {
                console.error('Error fetching records:', error);
            });
    }, []);

    const handleFilterchange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleFilterchange1 = (event) => {
        setSearchConsultant(event.target.value);
    };

    const filteredRecords = records.filter((record) =>
        record.vendor.toLowerCase().includes(searchTerm.toLowerCase())&&
        (searchConsultant === '' || record.cid === searchConsultant)
    );

    const servicesStyle = {
        backgroundImage: `url(${admin})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundColor :'#e6f4ff',
        width :'100%',
        height: '33vh',
    };

    return (
        <section style={{ background :'#f4f4f4' }}>
            <section id="bannerSection" style={servicesStyle}>
                <div className="container">
                    <h1 id="HR"></h1>
                </div>
            </section>
            <div className="container" style={{ background :'#ffffff' }}>
                <div className="col-12" style={{ margin:'0 auto'}}>
                    <div className="well well-small" style={{ textAlign:"left" }}>
                        <ul className="media-list">
                            <li className="media well well-small" style={{ marginTop:'10px',marginLeft:'-15px',marginRight:'15px',marginBottom:'-5px'}}>
                                <section className="breadcrumb" style={{ marginLeft:'5px', marginTop:'5px',marginRight:'5px'}}>
                                    <div  className="col-md-12 breadcrumbs" >
                                        <a href="/admin/Dashboard">Home</a> <i class="bi bi-chevron-double-right"></i> <a href="/admin/Consultantdashboard">Consultant Dashboard</a> <i class="bi bi-chevron-double-right"></i> <span> Submissions</span>
                                    </div>
                                </section>
                                <div className="container">
                                    <div className='row'>
                                        <div className="col-9" style={{ marginLeft:'25px'}}>
                                            <select size="1" style={{ width:'230px',height:'32px'}} className="dropdown" name="cid" value={searchConsultant} onChange={handleFilterchange1}>
                                            <option value="">--select consultant--</option>
                                            {consultants.map(item => (
                                            <option value={item.cid}>{item.fname} {item.lname}</option>
                                            ))} 
                                            </select>									  									
                                        </div>
                                        <div className="col-3" style={{ marginLeft:'-40px'}}>
                                            <input style={{ height:"35px",marginRight:"-5px",width:"255px"}} value={searchTerm} onChange={handleFilterchange} type='text' name='keyword' maxLength={150} placeholder='search vendor' />
                                            <button class="btn btn-warning" style={{ marginTop:"-5px",backgroundColor:"#ccc",border:"#ccc"}} type="button"><i class="bi bi-search" style={{ fontSize:"10px"}}></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="media-body" style={{ minHeight : '500px' , padding : '40px',marginTop:"-20px"}}>
                                    <h3 className="media-heading"></h3>
                                    
                                    <table className="mytable">
                                    <thead>
                                        <tr>
                                        <th>Vendor Name</th>
                                        <th>Contact Name</th>
                                        <th>Client Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Date & Time</th>
                                        <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {filteredRecords.map(item => (
                                        <tr  key={item.id}>
                                        <td>{item.vendor}</td>
                                        <td>{item.contactperson}</td>
                                        <td>{item.clientname}</td>
                                        <td>{item.email}</td>
                                        <td>{item.phone}</td>
                                        <td>{item.submitdate}</td>
                                        <td>{item.status}</td>
                                        </tr>
                                    ))} 
                                    </tbody>
                                    </table>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );

}

export default Submissions